import { ia, optionify } from 'lib/helpers/utility';
import { useStates } from 'lib/hooks/queries/states/useStates';

import SectionList from 'components/practice/UserPreferences/components/SectionList';
import Select from 'components/shared/Select/Select';

const StaffStatesSection = ({ formik }) => {
  const { data: statesData, isLoading, isError } = useStates();
  const stateOptions = optionify(statesData?.states);
  const statesError = isError ? 'Failed to load states. Please try again.' : undefined;

  const virtualIds = Array.isArray(formik.values.virtual_state_ids)
    ? formik.values.virtual_state_ids
    : [];
  const localIds = Array.isArray(formik.values.local_state_ids)
    ? formik.values.local_state_ids
    : [];
  const virtualSelected = stateOptions.filter((o) => virtualIds.includes(o.value));
  const localSelected = stateOptions.filter((o) => localIds.includes(o.value));

  return (
    <SectionList
      title="States"
      description="Select the states this provider is licensed to serve patients in-person (office) and virtually.">
      <Select
        isMulti
        name="local_state_ids"
        menuPortalTarget={document.body}
        value={localSelected}
        onChange={(opts) =>
          formik.setFieldValue('local_state_ids', ia(opts) ? opts.map((o) => o.value) : [])
        }
        label="Provider Office Location"
        inputId="select-staff-local-states"
        options={stateOptions}
        placeholder="Select states"
        isLoading={isLoading}
        disabled={isLoading || isError}
        error={statesError}
        isOptional
      />
      <Select
        isMulti
        name="virtual_state_ids"
        menuPortalTarget={document.body}
        value={virtualSelected}
        onChange={(opts) =>
          formik.setFieldValue('virtual_state_ids', ia(opts) ? opts.map((o) => o.value) : [])
        }
        label="Provider Virtual Location"
        inputId="select-staff-virtual-states"
        options={stateOptions}
        placeholder="Select states"
        isLoading={isLoading}
        disabled={isLoading || isError}
        error={statesError}
        isOptional
      />
    </SectionList>
  );
};

export default StaffStatesSection;
